var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isUserLogged)?_c('SignInRegister'):_vm._e(),(_vm.isUserLogged)?_c('TicketEntryForm',{attrs:{"contentKey":"cash-explosion-entry-text","requireDigits":"3","placeholderProp":"","headingProp":"","submitTextProp":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }